module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Chapter One")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola Wicks slept through her alarm. Again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola cracked an eyelid, an effort roughly equivalent to jerk-lifting a deadweight. Light stabbed her. She let the lid drop. Better. With the sun’s glare banned, scent intruded. Coffee, once seen as proof of a merciful God. These days, it merely dragged her back into a world she wanted no part of.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Go away.” Was that her voice, that baleful creaking thing?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The single word, cutting through the alarm’s insistent beeping, telegraphed a simmering fury that boiled over when Lola’s daughter spoke again. “I have to go to school. I made your coffee. Made my own breakfast. Got dressed. I’m leaving. You have to go to work. You can’t miss another day. Drink your fucking coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Whoa. Margaret was eight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola struggled to a sitting position and worked on her eyes again, brain striving toward the coherence that would allow an appropriate lecture. But by the time she got her eyes open and her mouth, too, Margaret was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Girl and dog stood alone, fresh snow whitecapping the sea of grass and sagebrush surrounding them. The sky, exhausted from a summer of soaring blue magnificence, had flattened into an ominous gray weight. Wind rushed past, gaining momentum from its charge down the slopes of Montana’s Rocky Mountain Front, stirring up a mingled cloud of dust and snow that nearly obscured the school bus laboring up the gravel road.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The girl cast a last glance toward the ranch house, its closed door. For years, a trio had awaited the bus, the girl, her mother and her father, the border collie frisking far afield, his missing leg no impediment to his harassment of the prairie dogs who popped out of one hole and whistled impertinence as the dog’s nose burrowed fruitlessly in another den.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But the father, dead these six months, would never wait for the bus with her again. Her mother, sunk in grief and rage, had become unreliable.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Margaret Laurendeau dug her fingers into the dog’s silky ruff. He ignored the prairie dogs and plastered himself to her, as if to make up for the missing adults. He would be waiting in this very spot when the bus deposited her in the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Bye, Bub,” she said to him as the bus doors sighed open just far enough to admit her reedy frame.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She looked back again at the sepulchral house and mouthed the words. “Bye, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Margaret’s unpardonable cursing had one good effect.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At least on this one morning, Lola’s first thought was not of Charlie, her husband of too few years, dead not six months by an eco-terrorist’s bomb.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dead")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The finality of the word drummed through Lola’s head all day, every day, a metronomic taunt, barely enough space between beat to catch a breath. Dead-dead-dead-dead-dead. Not coming back. Not ever. Her anguish a live thing, squeezing air from her lungs, clawing at her heart, corkscrewing through her gut. Simply to breathe, to stand upright, was a moment-by-moment struggle. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” she said when people spoke to her. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Their voices reached her from a great distance, distorted; their demands—that she rise every day, dress, care for her daughter, go to work—unreasonable. The only possible response: “But Charlie is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The longing to join him dragged at her, the means everywhere—from the paring knife in the kitchen drawer to the sturdy lead rope dangling from its hook in the horse’s shed, just the right length to drape over a rafter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Only one thing eased the seductive tug toward self-annihilation: the rectangular white pills with the rounded ends that she’d hoarded from her decade-earlier time as a foreign correspondent in Afghanistan. “I’m giving you these in case you get hurt over there, somewhere out in the back of beyond,” the doctor had said then. “If you have to use them, be careful. They’ll make you dopey. Be sure you’re somewhere safe. You won’t be able to dodge bullets if you take these things. And they’re as addictive as hell. But they’ll do the trick.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola thought the doctor had been overly cautious about that addictive business. A lifelong insomniac, she took the pills only once every few days, to catch up on the sleep that eluded her even more fiercely after Charlie’s death than before. The hours of nighttime wakefulness left her muzzy-headed and fumbling to complete the simplest puff pieces and weather stories at her job as a reporter at the "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Magpie Daily Express")]), _vm._v(", where she’d landed after quitting in protest when Baltimore newspaper had shuttered its foreign bureaus.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So, the occasional pill, suppressing the flare of panic at the realization that each one taken meant one day closer to the end of her stash. Until the next time she reached for the plastic bottle, its contents so much more effective than the sleeping meds that had eased her pre-end-of-her-world insomnia. She’d tried those again after Charlie’s death, achieving only the lightest of nightmare-bedeviled “rest.” But the pain pills! Like being sledgehammered into oblivion. Bliss. Or, more correctly, the numbness that passed for bliss in a world bereft of anything resembling happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She had a sense of Charlie, hovering close, the broad planes of his face askew with worry and disapproval. He’d been a sheriff—the first Indian sheriff in Montana—and in his last years had been increasingly preoccupied by pill-poppers and the bastards who fed their habit. The former, as Lola would have reminded him if he’d only given her the chance, lacked the sort of self-control she employed with her own legally prescribed meds. But no matter how quickly she turned, tangles of hair lashing her face as she whipped around to face him, she never caught him. It should have been a comfort, that lingering proximity, but she knew better. Charlie was pissed. Just like Margaret, just like everyone else she knew.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Especially just like Jan, her colleague at the "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Express")]), _vm._v(", her name flashing on the screen of the phone whose buzzing now competed with the alarm. Lola looked at the time. She knew why Jan was calling.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She slammed the alarm off, turned the phone over and stumbled toward the shower, twisting the “cold” knob and touching the hot not at all. As bad as Maggie’s language had been, Jan’s was liable to be a lot worse when Lola showed up an hour late for work—again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Two fast-gulped cups of coffee gone cold and a slice of toast later, a barely wakeful Lola steered her truck down Magpie’s snow-dusted main drag. To the west, the barrier of mountains mocked her. On the other side of those peaks it was probably still fall, golden leaves clinging to the aspens, the larches standing like burnished brass among the black-green mass of Ponderosa pines.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But in this part of Montana, east of the Continental Divide, fall was a cheat, snow blowing in as early as Labor Day and sometimes even before, harrying late vacationers with stinging pellets of ice. It would be April before streets remained reliably ice-free, June or even July before the final flakes fell.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The brick facade of the Daily Express loomed. Lola pulled into an angled parking space reserved for the newspaper’s customers, and wished she hadn’t. Jan shot from the front door, jacket unzipped, head and hands bare. The bank clock next door showed ten in the morning. The clock flipped over to the thermometer reading. Thirty degrees. In their part of the world, that counted as toasty, especially on such a sunny day. The light caught Jan’s coppery hair, its flamelike strands vying with the sparks in her narrowed eyes. Her customary braid was pulled forward over her shoulder, one end in her mouth, subjected to a savage chewing. Lola knew all the signs. She was in trouble. She threw the pickup into reverse. Too late. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jan smacked the flat of her hand against the window. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Don’t even think about it.")]), _vm._v(" The intention, if not the words themselves, clear through the rolled-tight window. She came around to the passenger side and climbed in. “Now you can leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola stared straight ahead. “Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“To Auntie Lena’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But that’s twenty miles away.” Lena lived on the nearby Blackfeet Reservation, “auntie” by virtue of some vague relationship to Charlie that Lola never quite grasped.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Right. And sitting in this parking space doesn’t get us there.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ve got a story due. I should write that first.” Lola was pretty sure she had something or other on her plate, likely a feature overdue by several days, normally a capital offense in her business. Jorkki Harkannen, the taciturn Finn who’d run the paper since Methuselah’s infancy and had postponed his retirement while awaiting her return to full productivity, had taken to assigning her “evergreens,” stories with no time elements, so that they could run whenever she got around to finishing them. She knew she’d pushed the limits of sympathy. “I’ll get better soon,” she’d promised him. Two months ago. Last week. Yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You and I have a different definition of soon.” Jorkki turned his head and pursed his lips. A thin stream of tobacco juice arced unerringly into a brimming coffee can, his signal that she was dismissed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You don’t have anything due today. You might not have anything due ever again, if you don’t get your act together.” Jan’s words banged around the cab.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola tried one last forlorn stall tactic. “Why Auntie Lena’s then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Just drive. You’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ten-thousand people lived on the Blackfeet Nation, rattling around in—as Lola always reminded people in the occasional freelance piece she did for national publications—an area the size of Delaware. She left it at that, no room in a news site’s limited real estate to describe the undulating plains angling up against the Front’s forested lower slopes, where the tribe had hunted until whitemen arriving soft and pampered from the East decided they themselves could better manage the area now known as Glacier National Park. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Now, the land once traveled by the tribe attracted millions of tourists and many more millions of dollars each year, nearly every one of which bypassed the pockets of the people who lived on its eastern border. But at least the tribe lived on the remnants of its former territory, unlike others who’d been marched hither and yon, dying by the thousands along the way, resettled in alien places due to the superior firepower of the invading whitemen.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Charlie was Blackfeet and so was Margaret, born with just enough Indian blood to qualify for the tribal enrollment that conferred some financial benefits and immensely greater emotional ones. Among them, the aunties. They swept in after Charlie’s death, cooking and cleaning and taking care of Margaret, and Lola, too, leading her from bed to bathroom and back again, spooning broth into her mouth in those early days when she thought it might indeed be possible to die of a broken heart.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But that organ lub-dubbed away in her chest, damnably strong, finally compelling her to rise from her bed and go through the motions of life. Which apparently wasn’t enough.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s this about?” Lola tried again. She drove slowly, steering the truck with exaggerated caution around the sharp curves and steep dips mandated by the rolling prairie, the effects of the pill still clouding her consciousness."), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jan’s fingers tattooed the dash. Her foot jammed the floorboards. She, like every other Montana native Lola knew, drove flat-out, passing on curves and damn the road conditions. On a normal day, Lola’s driving made Jan crazy. She bit down on her braid, shot Lola a sidelong glance, and deigned not to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The plains flowed by, brittle brown grasses jabbing through the patches of snow. Clouds of steam rose from Angus cattle, their winter coats growing in shaggy, munching at a green stripe of hay laid down that morning by the resident rancher. Behind them, the indifferent majesty of the Front, the land like its people stubbornly resistant to outsiders’ notions of taming.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Usually, Lola loved the drive to the reservation. On this day, her stomach churned under the twin assaults of the coffee’s acidity and her anxiety over whatever Jan had in store. Lena’s bungalow was a few miles beyond the reservation’s main town. Lola slid down a little behind the wheel, trying not to notice the gantlet of curious faces as the truck rolled along the main drag. She could imagine the flurry of phone calls and texts that would follow the truck’s passage. “She’s here with that whitegirl friend of hers. That other girl looked some upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A few minutes later, Lola thought town might have been the easier ordeal.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“One, two, three …” She counted the vehicles in front of Lena’s bungalow. Among them, Josephine DeRoche’s pickup, Angela Kills At Night’s fourth-hand Subaru, and the Ford sedan, more rust than paint, still driven—and driven fast—by Alice Kicking Woman, who had to be at least ninety. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is this what I think it is?” Lola braked to a stop and turned off the engine. Jan hopped out and came around and opened the driver’s side door. She grabbed Lola’s forearm, pulling so hard that Lola almost fell from the truck. Her tone was triumphant, her smile terrifying.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Welcome to your intervention.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d925eea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504084826.vue
// module id = 72
// module chunks = 0